import { render, staticRenderFns } from "./MyCommission.vue?vue&type=template&id=73b02840&"
import script from "./MyCommission.vue?vue&type=script&lang=js&"
export * from "./MyCommission.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports